import { useAppContext } from '../../appProvider/contextProvider';

const EcommercePrompt = ({title, message, button, theme}) => {
    
    const {selectedWebsite} = useAppContext();

    return  <div className="form-group">                   
    <h5 className="form-label text-dark medium px-3">Floating Label</h5>
    <div class="panel panel-bordered panel-primary price-drop-panel">                    
        <div class="panel-header m-0 text-center" style={{background: theme}}>
            <h6 class="medium mb-0 text-center">{title || 'Price drop alert?'}</h6>
            <button class="btn btn-rounded"><i class="icon icon-minus"></i></button>
        </div>
        <div class="panel-body">
            <div class="d-flex flex-column align-items-center">
                <figure>
                    <img src="https://via.placeholder.com/96" alt="Image" />
                </figure>
                <div class="text-center">
                    <h6 class="medium">Product Name</h6>
                    <p>{message || 'Notify me once this item is back in stock. Flating Lable Message'}</p>
                    <button class="btn btn-primary my-3" style={{background: theme,borderColor: theme}}>{button || 'Notify Me'}</button>
                    {selectedWebsite?.is_branding_enabled &&<p><small>Powerd by ChirpyWeb </small></p>}
                </div>
            </div>
        </div>
    </div>
</div>

} 

export default EcommercePrompt;